import { getData, postData } from 'helpers/RequestHelper';

export const postReturningUserData = () => {
  return new window.HeadlessCaptcha()
    .whenValidate()
    .then((data) => {
      return postData({
        url: '/auth/returning_user_redirect',
        body: {
          google_recaptcha_token: data?.token
        }
      })
        .then((response) => response.data)
        .catch((error) => window.Raven.captureException(error));
    })
    .catch((error) => window.Raven.captureException(error));
};

export const getReturningUserData = () => {
  return getData({
    url: `/auth/returning_user_data`
  })
    .then((response) => response.data)
    .catch((error) => window.Raven.captureException(error));
};

export const postPasswordlessEmail = (email) => {
  return postData({
    url: `/auth/send_passwordless_email`,
    body: {
      user: { email }
    }
  })
    .then((response) => response.data)
    .catch((error) => window.Raven.captureException(error));
};

export const postPasswordlessText = (email, phone) => {
  return postData({
    url: `/auth/send_passwordless_text`,
    body: {
      user: { email, phone }
    }
  })
    .then((response) => response.data)
    .catch((error) => window.Raven.captureException(error));
};
